<template>
  <div class="client-area-content">
    <!-- Formulario -->
    <ProfileForm
      ref="profileForm"
      @languageChanged="$emit('languageChanged', $event)"
      @avatar-changed="$emit('avatar-changed', $event)"
      @save-personal-data="$emit('save-personal-data', $event)"
    />
  </div>
</template>

<script>
import {
  SECONDARY_COLOR,
  ALL_LANGUAGES,
  NOTIFY_TIME_LONG,
} from '@/js/constants';
import { mapActions, mapState, mapGetters } from 'vuex';
import ProfilePage from '@/pages/profile-page.vue';
import ProfileForm from '@/components/Profile/ProfileForm.vue';

export default {
  name: 'Profile',
  components: {
    ProfileForm,
  },
  data() {
    return {
      ProfilePage,
      contraseña: false,
      languages: ALL_LANGUAGES,
      languageSelected: '',
      loaded: false,
      themes: ['Light'],
      isUserChangingPassword: false,
      SECONDARY_COLOR,
      selectedImage: this.avatar,
      selectedImageName: '',
      isSaveConfigDisabled: true,
      savePersonalButtonOptions: {
        text: `${this.$t('save_changes')}`,
        type: 'success',
        useSubmitBehavior: true,
      },
      submitChangePasswordOptions: {
        text: `${this.$t('save_new_password')}`,
        type: 'success',
        useSubmitBehavior: true,
      },
      submitConfigOptions: {
        text: `${this.$t('save_configuration')}`,
        type: 'success',
        useSubmitBehavior: true,
        disabled: true,
      },
      cancelChangePasswordOptions: {
        text: `${this.$t('cancel')}`,
        type: 'danger',
        onClick: this.hideChangePassword,
      },
      passwordOptions: {
        mode: 'password',
      },
      allowedPictureExtension: '.png, .jpg, .jpeg',
      avatarKey: 'avatar-key',
    };
  },
  computed: {
    ...mapGetters('user', ['isAdmin', 'userProfile']),
    ...mapGetters('company', ['userInfo']),
    ...mapState('user', ['userPasswords']),
    ...mapState('contact', [
      'showNewContactPopup',
      'enabled',
      'company',
      'companyName',
      'address',
      'addressName',
    ]),
    ...mapGetters('contact', ['contactInfo']),

    labelText() {
      return this.contactInfo.country === 'CL'
        ? this.$t('district')
        : this.$t('province');
    },
    dataField() {
      return this.contactInfo.country === 'CL'
        ? 'desc_comuna'
        : 'province';
    },
  },
  async beforeMount() {
    this.$f7.preloader.show();
    this.setCurrentRoute([
      {
        name: this.$t('profile'),
        disabled: false,
        page: 'ProfilePage',
        active: false,
      },
      {
        name: this.$t('contactManagement'),
        disabled: true,
        page: 'UsersManagementPage',
        active: true,
      },
    ]);
    this.loaded = true;
    this.$f7.preloader.hide();
  },
  methods: {
    ...mapActions('user', [
      'updatePassword',
      'updateAvatar',
      'updateUserPersonalData',
      'setUserNewPassword',
      'setUserOldPassword',
      'setConfirmNewPassword',
    ]),

    showChangePassword() {
      this.isUserChangingPassword = true;
    },
    goToCreateUserPage() {
      this.$f7router.navigate('/users/create', {
        transition: 'f7-fade',
      });
    },
    switchIsChangingPassword() {
      this.isUserChangingPassword = !this.isUserChangingPassword;
    },
    hideChangePassword() {
      this.isUserChangingPassword = false;
    },
    initAvatarForm() {
      this.$refs.avatarUploader.value = null;
    },
    async saveNewPassword() {
      // delega al hijo real
      return this.$refs.profileForm?.saveNewPassword?.();
    },
    onImageSelected(event) {
      const reader = new FileReader();
      const newImage = event.target.files[0];
      this.selectedImageName = newImage.name.replace(
        /(.{13})..+/,
        '$1...'
      );

      reader.onload = (e) => {
        this.selectedImage = e.target.result;
        this.userProfile.avatar = this.selectedImage;
        this.avatarKey = `avatar-key-${Math.random()}`;
        this.$emit('avatar-changed', this.selectedImage);
      };

      reader.onerror = (error) => {
        this.$f7.dialog.alert(error);
      };

      reader.readAsDataURL(newImage);
    },
    async onUpdatePhoto() {
      const self = this;
      try {
        if (!this.selectedImage) {
          this.$notifyDX(
            {
              message: this.$t('profilePhotoNotSelected'),
              width: 150,
            },
            'error',
            NOTIFY_TIME_LONG
          );
          return;
        }

        this.$notifyDX(
          {
            message: this.$t('updating_avatar'),
            width: 150,
          },
          'info',
          2000
        );

        await this.updateAvatar({ newAvatar: this.selectedImage });
        self.$f7.dialog.close();
        this.$notifyDX(
          {
            message: this.$t('avatar_updated'),
            width: 150,
          },
          'success',
          2000
        );
        this.selectedImage = undefined;
      } catch (error) {
        this.$f7.dialog.close();

        self.$f7.dialog.close();
        this.$notifyDX(
          {
            message: this.$t(error.errorCodes[0]),
            width: 150,
          },
          'error',
          NOTIFY_TIME_LONG
        );
      } finally {
        this.initAvatarForm();
      }
    },
    getPhotoExtension(photoB64) {
      return photoB64.split(';base64,')[0].split('image/')[1];
    },
    languageChanged(e) {
      let key = '';
      for (const lang in ALL_LANGUAGES) {
        if (ALL_LANGUAGES[lang].value === e.value) {
          key = ALL_LANGUAGES[lang].key;
        }
      }
      this.$emit('languageChanged', { key, value: e.value });
    },
    passwordComparison() {
      return this.userPasswords.newPassword;
    },
    translateLanguageOption(e) {
      return `${this.$t(e.value)}`;
    },
    translateLang(row) {
      return this.$t(`${row.language}`);
    },
    ...mapActions('breadcrumb', ['setCurrentRoute']),
  },
};
</script>
